const config = {
    "api": {
        "baseURL": "https://apitest.xgps.us/api",
    },
    "exports": {
        "baseURL": "https://apitest.xgps.us/tmp/",
    },
    "customize": {
        "baseURL": "https://apitest.xgps.us/api/v1",
    },
    "privatelabel": {
        "baseURL": "https://privatelabelxgps.prometheuspro.dev",
    },
}

export default config